import MainTotalEnergyUseComponent from '../../../common/layout/components/main.total.energy.use.component';
import MainProcessEnergyUseComponent from '../../../common/layout/components/main.process.energy.use.component';
import MainInstantaneousPowerComponent from '../../../common/layout/components/main.instantaneous.power.component';
import MainProcessInstantaneousPowerComponent from '../../../common/layout/components/main.process.instantaneous.power.component';
import MachineStatusDetailContainer from '../../machinestatus/containers/machine.status.detail.container';
import KpiMachineLayoutComponent from '../../../common/layout/components/kpi.machine.layout.component';
import CustomTotalEnergyUseContainer from '../../customgraph/containers/custom.total.energy.use.container';
import CustomAirQualityContainer from '../../customgraph/containers/custom.airquality.container';
import CustomPowerUsageContainer from '../../customgraph/containers/custom.power.usage.container';
import CustomTimeSeriesContainer from '../../customgraph/containers/custom.timeseries.container';
import KpiOneContainer from '../../kpi/containers/kpi.graph.one.container';

import { customWidgetEndpointLayers } from '../../../config/widgetEndpoints';

export const COMPONENT_MAP = {
  totalEnergy: MainTotalEnergyUseComponent,
  processEnergy: MainProcessEnergyUseComponent,
  instantaneousPower: MainInstantaneousPowerComponent,
  equipmentInstantaneousPower: MainProcessInstantaneousPowerComponent,
  machineStatus: MachineStatusDetailContainer,
  kpi: KpiMachineLayoutComponent,
  CustomTotalEnergyUseContainer,
  CustomAirQualityContainer,
  CustomPowerUsageContainer,
  CustomTimeSeriesContainer,
  KpiOneContainer
};

export const createChartConfig = (type, level, params = {}) => {
  const baseConfigs = {
    totalEnergy: {
      component: 'totalEnergy',
      graph_name: 'Total energy use (kWh)',
      drilldownlevel: level
    },
    processEnergy: {
      component: 'processEnergy',
      graph_name: 'Process energy use (kWh)',
      drilldownlevel: level,
      disableDrilldown: true
    },
    instantaneousPower: {
      component: 'instantaneousPower',
      graph_name: 'Instantaneous Power (kW)',
      drilldownlevel: level
    },
    equipmentInstantaneousPower: {
      component: 'equipmentInstantaneousPower',
      graph_name: 'Equipment Instantaneous Power (kW)',
      drilldownlevel: level
    }
  };
  return {
    ...baseConfigs[type],
    ...params
  };
};

export const getComponentForGraph = (graph) => {
  const level =
    graph.layer_type === 'component'
      ? 'ComponentLayer'
      : graph.layer_type === 'process'
      ? 'ProcessLayer'
      : graph.layer_type === 'equipment'
      ? 'EquipmentLayer'
      : graph.layer_type === 'machine'
      ? 'Machine'
      : graph.layer_type === 'plant'
      ? 'Plant'
      : 'Company';

  // Special case: sensor_addon_summary
  if (graph.category === 'graph' && graph.graph_type === 'sensor_addon_summary') {
    return {
      component: COMPONENT_MAP.CustomTotalEnergyUseContainer,
      config: {
        drilldownlevel: 'Machine',
        graph_name: graph.name,
        customGraphApi: customWidgetEndpointLayers.energyUseSummary,
        flexibleEquipmentEnabled: true,
        ...graph
      }
    };
  }

  // Special case: sensor_addon_timeseries handling 2 api endpoint as per layer type
  if (graph.category === 'graph' && graph.graph_type === 'sensor_addon_timeseries') {
    //console.log('sensor_addon_timeseries', graph)
    return {
      component: COMPONENT_MAP.CustomPowerUsageContainer,
      config: {
        drilldownlevel: 'Machine',
        graph_name: graph.name,
        layer_type: 'incomer',
         sensor_type: graph.sensor_type,
         
        customGraphApi:
          graph?.layer_type === 'water_flow'
            ? customWidgetEndpointLayers.waterflow
            : customWidgetEndpointLayers.layeredPowerUsage,
        flexibleEquipmentEnabled: true,
        ...graph
      }
    };
  }

  // Special case: Air quality
  if (
    graph.category === 'graph' &&
    ['aq_pm1', 'aq_co2', 'aq_voc', 'aq_pm2_5', 'aq_pm4', 'aq_pm10'].includes(graph.graph_type)
  ) {
    return {
      component: COMPONENT_MAP.CustomAirQualityContainer,
      config: {
        drilldownlevel: 'Machine',
        slug: 'aq_pm1', // could be dynamic
        customGraphApi: customWidgetEndpointLayers.energyUseSummary,
        ...graph
      }
    };
  }

  // Special case: temperature & humidity
  if (graph.category === 'graph' && ['temperature', 'humidity'].includes(graph.graph_type)) {
    return {
      component: COMPONENT_MAP.CustomTimeSeriesContainer,
      config: {
        drilldownlevel: 'Home',
        ...graph
      }
    };
  }
  if (graph.category === 'graph' && graph.graph_type === 'company_kpi') {
    return {
      component: COMPONENT_MAP.KpiOneContainer,
      config: {
        drilldownlevel: 'Home',
        graph_name: graph.name,
        ...graph
      }
    };
  }

  // Machine status
  if (graph.category === 'machine_status') {
    return {
      component: COMPONENT_MAP.machineStatus,
      config: {
        processDetails: {
          drilldownlevel: level,
          ...graph,
          isNewDashboard: true
        }
      }
    };
  }

  // Equipment KPI
  if (graph.category === 'equipment_kpi') {
    return {
      component: COMPONENT_MAP.kpi,
      config: {
        processDetails: {
          drilldownlevel: 'selectGraphLayer',
           graph_name: graph.name,
          selectedGraphNames: graph.kpi_name,
          ...graph,
          isNewDashboard: true
        }
      }
    };
  }

  // Default mapping by name
  const lowerName = graph.name?.toLowerCase() || '';
  let chartType;

  if (lowerName.includes('total energy')) chartType = 'totalEnergy';
  else if (lowerName.includes('process energy')) chartType = 'processEnergy';
  else if (lowerName.includes('equipment instantaneous') || lowerName.includes('equipment power'))
    chartType = 'equipmentInstantaneousPower';
  else if (lowerName.includes('instantaneous') || lowerName.includes('power'))
    chartType = 'instantaneousPower';

  return {
    component: COMPONENT_MAP[chartType],
    config: createChartConfig(chartType, level, {
      ...graph
    })
  };
};
